import { PortableTextComponentProps } from '@portabletext/react'
import cx from 'classnames'

import { SanityQuote } from '@data/sanity/queries/types/content'

import Icon from '@components/icon'

type QuoteValue = Pick<SanityQuote, 'author' | 'alignment' | 'text'>

const Quote = ({ value }: PortableTextComponentProps<QuoteValue>) => {
  const { text, author, alignment } = value

  return (
    <div
      className={cx({
        [`text-${alignment}`]: alignment,
      })}
    >
      <Icon
        name="Quote"
        className="fill-current text-pageText w-[29px] inline"
      />
      <p className="text-2xl !text-pageText leading-relaxed mt-8">{text}</p>
      {!!author && (
        <p className="!text-pageText opacity-60 text-base mt-8">{author}</p>
      )}
    </div>
  )
}

export default Quote
